import ScrollStick from '../util/scroll-stick';
import { getViewportSizeName } from '../util/general-util';

class SocialShare {
	constructor(el) {
		this.el = el;

		this.bottomStopEl = document.querySelector('.tmpl-resource-single');
		this.shareStickyEl = this.el.querySelector('.tmpl-resource-single__share-icons--sticky');

		this.lastViewportSizeName = getViewportSizeName();

		this.initSticky();

		window.addEventListener('resize', () => {
			const viewportSizeName = getViewportSizeName();

			if (this.lastViewportSizeName !== viewportSizeName) {
				this.lastViewportSizeName = viewportSizeName;

				this.initSticky();
			}
		});
	}

	getStickyTopSpacing() {
		return this.lastViewportSizeName === 'large' ? 100 : 80;
	}

	initSticky() {
		if (this.getViewportSizeName === 'small') {
			if (this.sidebarSticky) {
				this.sidebarSticky.disable();
			}
			return;
		}

		this.sidebarSticky = new ScrollStick(this.shareStickyEl, this.getStickyTopSpacing());
	}

}

export default SocialShare;